"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _lodash = require("lodash");
var _reactBlueprintLibrary = require("react-blueprint-library");
var _dateFns = require("date-fns");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * A Listing component
 *
 * @param {object} props Properties used for the component
 *
 * @returns {React.ReactElement} PressReleaseList
 */
function PressReleaseList(props) {
  if (!props.fields) return null;
  var [items, setItems] = (0, _react.useState)([]);
  var [displayItems, setDisplayItems] = (0, _react.useState)([]);
  var [pageNum, setPageNum] = (0, _react.useState)(1);
  var [resPerPage, setResPerPage] = (0, _react.useState)(10);
  var totalPages = displayItems === null || displayItems === void 0 ? void 0 : displayItems.length;
  var displayedNews = displayItems === null || displayItems === void 0 ? void 0 : displayItems.slice((pageNum - 1) * resPerPage, pageNum * resPerPage);
  var fetchData = () => {
    var pr = [];
    pr = props.fields.data.dailynews.results.items;
    pr = (0, _lodash.orderBy)(pr, ['item.postDate.jss.value'], ['desc']);
    setItems(pr);
  };
  (0, _react.useEffect)(() => {
    fetchData();
    setDisplayItems(items);
  }, []);
  (0, _react.useEffect)(() => {
    var filteredPR = [];
    if (Array.isArray(props.topics) && props.topics.length > 0 && items.length > 0) {
      props.topics.map(function (x) {
        Object.entries(items).forEach(entry => {
          if (entry[1].item.topics.targetItems.find(t => t.field.value === x)) {
            var idx = filteredPR.findIndex(itm => itm.item.id === entry[1].item.id);
            if (idx === -1) {
              filteredPR.push(entry[1]);
            }
          }
        });
        return x;
      });
      setDisplayItems(filteredPR);
      setPageNum(1);
    } else {
      if (props.topics.length == 0) {
        //no filters
        setDisplayItems(items);
      }
    }
  }, [props.topics]);
  var onChange = (page, event) => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
    setPageNum(page);
  };
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", null, "Found ", totalPages, " Items"), /*#__PURE__*/_react.default.createElement("ul", {
    className: "list-group list-group-flush"
  }, (0, _lodash.map)(displayedNews, (sc, idx) => {
    return /*#__PURE__*/_react.default.createElement("li", {
      "data-testid": "prlst_".concat(idx),
      key: "li_".concat(idx),
      className: "list-group-item"
    }, /*#__PURE__*/_react.default.createElement("p", null, (0, _dateFns.format)(new Date(sc.item.postDate.jss.value), 'MMMM dd, yyyy')), /*#__PURE__*/_react.default.createElement("div", {
      className: "list-item-preview-text"
    }, /*#__PURE__*/_react.default.createElement("a", {
      href: sc.item.url + "",
      target: "_self"
    }, sc.item.headline.value)));
  })), /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Pagination, {
    currentPage: pageNum,
    itemsPerPage: 10,
    numberOfItems: totalPages,
    onChange: onChange
  }));
}
var _default = exports.default = PressReleaseList;